export default __webpack_public_path__ + "static/image045-928d3435c9e919a76ba127a5321d143a.gif";